module.exports = __webpack_public_path__ + "completed.1797152b.svg";